const translateDataSourceSelection = {
  select: '选择数据源：',
  select2: '选择2个数据源:',
};

export default translateDataSourceSelection;
